import { WORLD_CUP_EVENTS, WORLD_CUP_DATA_SOURCE } from '@/packages/components/hook/useWorldCup'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-world-cup-btn',
  type: 'component-business',
  label: '世界杯竞猜',
  icon: 'icon-xy-world-cup-btn',
  defaultWidth: 0,
  defaultHeight: 0
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  noView: { type: Boolean, default: true },
  activityId: { type: String, default: '' },
  /** 赛事日期列表子项组件 UUID */
  dateListItemLayoutUUID: { type: String, default: '' },
  /** 日期切换长度（上一页/下一页日期步长） */
  dateSwitchLength: { type: Number, default: 5 }
}

/**
 * 组件开放方法事件
 */
export const events = WORLD_CUP_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = WORLD_CUP_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-world-cup-btn'
  }
]
